import { Flat, FloorScheme, ISpot, RoomType, RoomTypeItem, SetBuilding, SpotRank, WallMaterialType, Block, Blocks, FlatsFloorInfo, FloorInfoSet1, FloorInfoSet1Ex, InfoAboutFlat } from "../../shared/models/models";
import { Floor } from "./../../shared/models/models";
import { Component, OnInit, Input } from "@angular/core";
import { EventService } from "./../../shared/services/event.service";
import { ServerService } from "../../shared/services/server.service";
import { OneFlatSalesSet2 } from "../flats-modal/flats-modal.component";
import { Subscription } from "rxjs";
import { HttpResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: "app-spot-form-editor",
  templateUrl: "./spot-form-editor.component.html",
  styleUrls: ["./spot-form-editor.component.scss"]
})
export class SpotFormEditorComponent implements OnInit {
  @Input() materialIsChecked: boolean = false;
  @Input() spotObject: ISpot;
  @Input() livingComplexID: number = 0;
  @Input() wallMaterialTypes_: WallMaterialType[] = [];
  @Input() buildingRoomTypes: RoomType[] = [];
  @Input() buildingClasses: SpotRank[] = [];

  appartmentModal: boolean = false;
  wallModal: boolean = false;
  max_flatCount: number = 0;
  flat: Flat = {
    flatRoom: null,
    flatNumber: "",
    saleDate: "",
    flatID: null,
    flatConfigurationID: null,
    columnID: null,
    roomCountID: null,
    isCornerFlat: false
  };
  loader: boolean = false;

  flatFlag: boolean = false;
  selectedFlat;
  selectedFlatId: number = -1;
  floorCount: number = 0;

  loading: boolean = false;

  flatsfloorsModal: boolean = false;

  allSets: FlatsFloorInfo;
  set1: FloorInfoSet1[] = [];

  obj: FloorInfoSet1Ex[] = [];
  maxFlatCount: number = 0;

  blocks: Blocks[] = [];

  block: Block;

  spotN1: boolean = false;
  spotN2: boolean = false;
  floorsCommercial: boolean = false;

  commercialFirstFloor = false;
  commercialSecondFloor = false;

  countOfOpen = 0;
  changeAppartment = false;

  subscription: Subscription;

  spotForm: string = "information";

  firstFloorArea: number;
  secondFloorArea: number;

  constructor(
    private serverService: ServerService,
    private event: EventService,
    public toastr: ToastrService
  ) { }

  ngOnInit() {
    this.init();
  }

  init() {
    this.serverService.getBuildingFlatsInfo(this.spotObject.id).then(res => {
      this.firstFloorArea = res.set1.find(x => x.floorID === 1).flatArea;
      let $secondFloorArea = res.set1.find(x => x.floorID === 2);
      this.secondFloorArea = $secondFloorArea ? $secondFloorArea.flatArea : null;

    })

    this.serverService.getOtherRooms(this.spotObject.id).then(res => {
      this.commercialFirstFloor = res.some(x => x.roomTypeItemID === 10101 || x.roomTypeItemID === 10301);
      this.commercialSecondFloor = res.some(x => x.roomTypeItemID === 10102 || x.roomTypeItemID === 10302);
    });


    this.floorCount = this.spotObject.floors;
    this.loader = true;
    this.block = {
      id: null,
      title: "Блок",
      blockNumber: null,
      buildingID: this.spotObject.id
    };
    this.loadBlocks();
    this.getBuildingFurnishItemTemplate();



    //Если пятно имеет этажей инициализирует схему пятна
    this.initializeSpotScheme(this.spotObject);

    //Если пятно не имеет материалов стен инициализирует массив материалов
    if (!this.spotObject.wallMaterials) {
      this.spotObject.wallMaterials = [];
      this.initializeWallMaterials();
    } else {
      this.wallMaterialsHas();
    }
    //Если пятно не имеет ранк инициализирует массив ранков
    if (!this.spotObject.spotRanks) {
      this.spotObject.spotRanks = [];
      this.initializeRanks();
    }

    //Если пятно не имеет помещения инициализирует массив помещении
    if (!this.spotObject.commercialRooms) {
      this.spotObject.commercialRooms = [];
      let roomTypeID = this.buildingRoomTypes.find(
        x => x.title === "Коммерческие помещения"
      ).id;
      this.initializeOtherRooms(roomTypeID, this.spotObject.commercialRooms);
    }

    if (!this.spotObject.auxiliaryRooms) {
      this.spotObject.auxiliaryRooms = [];
      let roomTypeID = this.buildingRoomTypes.find(
        x => x.title === "Вспомогательные помещения"
      ).id;
      this.initializeOtherRooms(roomTypeID, this.spotObject.auxiliaryRooms);
    }
    if (!this.spotObject.parkingRooms) {
      this.spotObject.parkingRooms = [];
      let roomTypeID = this.buildingRoomTypes.find(x => x.title === "Парковка")
        .id;
      this.initializeOtherRooms(roomTypeID, this.spotObject.parkingRooms);
    }
    if (!this.spotObject.mansardRooms) {
      this.initializeMansard();
    }
    this.event.initialize.subscribe(r => {
      this.spotObject = null;
      this.spotObject = r;

      if (r.commercialRooms.find(x => x.id === 10101).checked || r.commercialRooms.find(x => x.id === 10301).checked) {
        this.commercialFirstFloor = true;
      } else {
        this.commercialFirstFloor = false;

      }

      if (r.commercialRooms.find(x => x.id === 10102).checked || r.commercialRooms.find(x => x.id === 10302).checked) {
        this.commercialSecondFloor = true;
      } else {
        this.commercialSecondFloor = false;

      }

      this.initializeSpotScheme(r);
    });

    this.subscription = this.event.getChanges().subscribe(res => {
      if (res) {
        this.changeAppartment = res;
      }
    });
  }

  loadBlocks() {
    this.serverService.getBlocks(this.spotObject.id).then(res => {
      this.blocks = res;
    });
  }

  initializeSpotScheme(spot: ISpot) {
    this.max_flatCount = 0;
    spot.apartmentScheme = [];
    spot.countRoomsOfFloor = [];
    this.serverService.getBuildingFlatsInfo(spot.id).then(res => {
      setTimeout(() => {
        spot.apartmentCount = res.set1;
        spot.flatConfiguration = res.set2;
        spot.countRooms = res.set3;
        spot.flatRealization = res.set4;
        this.allSets = res;
        this.set1 = this.allSets.set1.sort(function (a, b) {
          return b.floorID - a.floorID;
        });
        if (this.set1.length > 0) {
          this.maxFlatCount = this.getMaxFlatCount(this.set1);
        }
        this.obj = this.updateObj(this.allSets);
        let lengthOfObj = this.obj.length;
        // let lengthCountRoom = this.spotObject.countRoomsOfFloor.length;

        //TODO
        this.spotObject.commercialRooms.forEach(element => {
          if (element.checked === true) {
            if (element.id === 10101 || element.id === 10301) {
              this.obj.splice(lengthOfObj - 1, 1);
              this.floorsCommercial = true;
            }
            if (element.id === 10102 || element.id === 10302) {
              this.obj.splice(lengthOfObj - 2, 1);
              this.floorsCommercial = true;
            }

          }
        });

        this.spotObject.parkingRooms.forEach(element => {
          if (element.checked === true) {
            if (element.id === 30401) {
              this.obj.splice(lengthOfObj - 1, 1);
              this.floorsCommercial = true;
            }
            if (element.id === 30402) {
              this.obj.splice(lengthOfObj - 2, 1);
              this.floorsCommercial = true;
            }

          }
        });

        this.countMaxFlat(res.set1);
        this.initializeFlatCountsArray(res.set2);
        this.initializeFlatSchemeArray(spot);
        this.drawFlatScheme(res.set4, spot);
      }, 100);
    });

  }

  countMaxFlat(res: Floor[]) {
    for (let item of res) {
      this.spotObject.countRoomsOfFloor.push(
        new Array(this.spotObject.countRooms.length).fill(0)
      );
      if (item.flatCount > this.max_flatCount)
        this.max_flatCount = item.flatCount;
    }
  }

  initializeFlatCountsArray(res: FloorScheme[]) {
    for (let item of res) {
      if (item.roomCountID)
        this.spotObject.countRoomsOfFloor[item.floorID - 1][
          item.roomCountID - 1
        ] = item.flatCount;
    }
  }

  initializeFlatSchemeArray(spot: ISpot) {
    for (let i = 0; i < spot.countRoomsOfFloor.length; i++) {
      spot.apartmentScheme.push(
        new Array(
          this.max_flatCount > 6
            ? this.max_flatCount
            : this.spotObject.countRooms.length
        )
      );
      for (let j = 0; j < spot.apartmentScheme[i].length; j++) {
        spot.apartmentScheme[i][j] = Object.assign({}, this.flat);
      }
      let last_index = 0;
      for (let j = 0; j < spot.countRoomsOfFloor[i].length; j++) {
        let col = 1;
        this.generateHasFlatsInfo(
          i,
          j,
          last_index,
          col,
          spot.apartmentScheme[i]
        );
        last_index += spot.countRoomsOfFloor[i][j];
        if (spot.countRoomsOfFloor[i][j] == 0) {
          spot.countRoomsOfFloor[i][j] = null;
        }
      }
    }

    let apartmentCountLength = this.spotObject.apartmentCount.length;
    //TODO
    this.spotObject.commercialRooms.forEach(element => {
      if (element.checked === true) {
        if (element.id === 10101 || element.id === 10301) {
          this.spotObject.apartmentCount.splice(apartmentCountLength - 1, 1);
        }
        if (element.id === 10102 || element.id === 10302) {
          this.spotObject.apartmentCount.splice(apartmentCountLength - 2, 1);

        }
      }
    });
    this.spotObject.parkingRooms.forEach(element => {
      if (element.checked === true) {
        if (element.id === 30401) {
          this.spotObject.apartmentCount.splice(apartmentCountLength - 1, 1);
        }
        if (element.id === 30402) {
          this.spotObject.apartmentCount.splice(apartmentCountLength - 2, 1);

        }
      }
    });

  }

  generateHasFlatsInfo(i: number,j: number,last_index: number,col: number,array_scheme: Flat[]) {
    for (
      let count = last_index;
      count < last_index + this.spotObject.countRoomsOfFloor[i][j];
      count++
    ) {
      array_scheme[count].flatRoom = j + 1;
      let element = this.spotObject.flatConfiguration.filter(function (element) {
        if (element.floorID == i + 1 && element.roomCountID == j + 1)
          return element;
      });
      if (element.length > 0) {
        array_scheme[count].flatConfigurationID =
          element[0].flatConfigurationID;
        array_scheme[count].roomCountID = element[0].roomCountID;
      }
      array_scheme[count].columnID = col++;
    }
  }

  initializeOtherRooms(roomTypeID: number, otherRoomType: RoomTypeItem[]) {
    if (this.buildingRoomTypes.length > 0) {
      let buildEx = this.buildingRoomTypes.find(x => x.id === roomTypeID).type;
      if (typeof buildEx !== "undefined") {
        for (let rooms of buildEx) {
          let new_room = Object.assign({}, rooms);
          new_room.checked = false;
          new_room.area = null;
          new_room.placeCount = null;
          new_room.photoFileID = 0;
          otherRoomType.push(new_room);
        }
      }
    }

    this.serverService
      .getBuildingOtherRooms(this.spotObject.id, roomTypeID)
      .then(res => {
        for (let item of res) {
          let otherRoom = otherRoomType.find(x => x.id == item.roomTypeItemID);
          if (otherRoom) {
            otherRoom.area = item.area;
            otherRoom.placeCount = item.placeCount;
            otherRoom.checked = true;
            otherRoom.photoFileID = item.photoFileID;
          }
        }
      });
  }

  initializeMansard() {
    this.spotObject.mansardRooms = {
      id: -1,
      title: "Мансарда",
      checked: this.spotObject.hasMansard,
      placeCount: null,
      area: null
    };
    if (this.spotObject.hasMansard) {
      this.serverService
        .getBuildingOtherRooms(this.spotObject.id, -1)
        .then(res => {
          for (let item of res) {
            this.spotObject.mansardRooms.area = item.area;
            this.spotObject.mansardRooms.placeCount = item.placeCount;
          }
        });
    }
  }

  initializeRanks() {
    for (let ranks of this.buildingClasses) {
      let new_rank = Object.assign({}, ranks);
      new_rank.checked = this.spotObject.rank_id === new_rank.id;
      this.spotObject.spotRanks.push(new_rank);
    }
  }

  initializeWallMaterials() {
    let new_materials: WallMaterialType;
    for (let item_material of this.wallMaterialTypes_) {
      new_materials = { id: 0, title: "", wall_material: [], active: false };
      new_materials.id = item_material.id;
      new_materials.title = item_material.title;
      new_materials.active = item_material.active;
      this.spotObject.wallMaterials.push(new_materials);
      if (typeof item_material.wall_material !== "undefined") {
        for (let item of item_material.wall_material) {
          new_materials.wall_material.push(Object.assign({}, item));
        }
      }
    }

    this.serverService
      .getBuildingsWallMaterials(this.spotObject.id)
      .then(res => {
        for (let item of res) {
          for (let wall of this.spotObject.wallMaterials) {
            let wallMaterial = wall.wall_material.find(
              x => x.id == item.wallMaterialID
            );
            if (wallMaterial) {
              wallMaterial.checked = true;
              this.materialIsChecked = true;
            }
          }
        }
      });
  }

  changedFloor(length: number) {
    if (length > this.spotObject.countRoomsOfFloor.length) {
      let new_floor: Floor;
      this.spotObject.apartmentCount = [];
      for (let i = 0; i < length; i++) {
        new_floor = {
          floorID: i + 1,
          floorTitle: "Этаж " + (i + 1),
          flatCount: null,
          flatArea: null
        };
        this.spotObject.countRoomsOfFloor.push(
          new Array(this.spotObject.countRooms.length).fill(0)
        );
        this.spotObject.countRoomsOfFloor = this.spotObject.countRoomsOfFloor.reverse();
        this.spotObject.apartmentScheme.push(
          new Array(
            this.max_flatCount > 6
              ? this.max_flatCount
              : this.spotObject.countRooms.length
          )
        );
        for (let j = 0; j < this.spotObject.apartmentScheme[i].length; j++) {
          this.spotObject.apartmentScheme[i][j] = Object.assign({}, this.flat);
        }
        this.spotObject.apartmentCount.push(new_floor);
      }
      this.spotObject.apartmentCount = this.spotObject.apartmentCount.reverse();
    } else {
      this.spotObject.countRoomsOfFloor.splice(
        length,
        this.spotObject.countRoomsOfFloor.length - length
      );
      this.spotObject.apartmentCount.splice(
        length,
        this.spotObject.apartmentCount.length - length
      );
      this.spotObject.apartmentScheme.splice(
        length,
        this.spotObject.apartmentScheme.length - length
      );
    }
  }

  addFlatLoading: boolean = false;
  addFlats() {
    if (
      this.livingComplexID !== 0 &&
      this.floorCount !== this.spotObject.floors
    ) {
      this.addFlatLoading = true;
      let building: SetBuilding = {
        LivingComplexID: this.livingComplexID,
        BuildingID: this.spotObject.id,
        BuildingNumber:
          this.spotObject.number === "" ? null : this.spotObject.number,
        FloorCount: this.spotObject.floors,
        FlatCount: this.spotObject.apartment_number,
        FlatArea: this.spotObject.totalFlatArea,
        BuildingClassID:
          this.spotObject.rank_id === 0 ? null : this.spotObject.rank_id,
        HomeNumber:
          this.spotObject.homeNumber === "" ? null : this.spotObject.homeNumber,
        HasMansard: this.spotObject.hasMansard
      };
      this.serverService.setBuilding(building).then(res => {
        this.addFlatLoading = false;
        this.appartmentModal = true;
        building = null;
        this.floorCount = this.spotObject.floors;

      });
    } else {
      this.appartmentModal = true;
    }
  }

  changeClass(rank: SpotRank) {
    for (let item of this.spotObject.spotRanks) {
      item.checked = false;
    }
    if (rank.id !== this.spotObject.rank_id) {
      this.spotObject.rank_id = rank.id;
      this.spotObject.rank = rank.title;
      rank.checked = true;
    } else {
      this.spotObject.rank_id = null;
      this.spotObject.rank = "";
    }
  }

  appModalWindowTitle: string = "";
  chooseFlat(flat: InfoAboutFlat) {
    this.selectedFlatId = flat.flatID ? flat.flatID : -1;
    this.selectedFlat = flat;
    this.appModalWindowTitle = "Квартира № " + this.selectedFlat.flatNumber;
    this.otherRoomFlag = false;
    this.flatFlag = true;
  }

  otherRoomFlag: boolean;
  selectedOtherRoom: RoomTypeItem;
  openOtherRoom(otherRoom: RoomTypeItem) {
    this.otherRoomFlag = true;
    let room: {
      id: number;
      roomTypeID: number;
      title: string;
      info: { area: number; placeCount: number; photoFileID: number };
    };
    room = {
      id: otherRoom.id,
      roomTypeID: otherRoom.roomTypeID,
      title: otherRoom.title,
      info: {
        area: otherRoom.area,
        placeCount: otherRoom.placeCount,
        photoFileID: otherRoom.photoFileID
      }
    };
    this.selectedFlat = room;
    this.selectedOtherRoom = otherRoom;
    this.appModalWindowTitle = otherRoom.title;
    this.flatFlag = true;
  }

  reloadData(event) {
    if (this.otherRoomFlag) {
      this.spotObject.totalFlatArea +=
        event.area -
        (this.selectedOtherRoom.area ? this.selectedOtherRoom.area : 0);
      //this.spotObject.apartment_number += event.PlaceCount[0] - (this.selectedOtherRoom.placeCount ? this.selectedOtherRoom.placeCount : 0);
      this.selectedOtherRoom.area = event.area;
      this.selectedOtherRoom.placeCount = event.placeCount;

      this.serverService.getBuildingFlatsInfo(this.spotObject.id).then(res => {
        this.firstFloorArea = res.set1.find(x => x.floorID === 1).flatArea;
        this.secondFloorArea = res.set1.find(x => x.floorID === 2).flatArea;
      });

      this.serverService
        .getBuildingOtherRooms(
          this.spotObject.id,
          this.selectedOtherRoom.roomTypeID
        )
        .then(res => {
          this.selectedOtherRoom.photoFileID = res.find(
            x => x.roomTypeItemID === this.selectedOtherRoom.id
          ).photoFileID;
        });
    } else {
      this.spotObject.totalFlatArea +=
        event.flatArea -
        (this.selectedFlat.flatArea ? this.selectedFlat.flatArea : 0);
      if (event.saleDate != null) {
        this.spotObject.residueFlatCount -= 1;
      }
      //this.spotObject.totalFlatAmount += event.priceAmount;
      this.selectedFlat.flatID = event.ID;
      this.selectedFlat.flatNumber = event.flatNumber;
      this.selectedFlat.isCornerFlat = event.isCornerFlat;
      this.selectedFlat.saleDate = event.saleDate;
      this.selectedFlat.flatArea = event.flatArea;
    }
  }

  wallMaterialsHas() {
    for (let wall of this.spotObject.wallMaterials) {
      let wallMaterial = wall.wall_material.find(x => x.checked == true);
      if (wallMaterial) {
        this.materialIsChecked = true;
        break;
      }
    }
  }

  public drawFlatScheme(res: any[], spot: ISpot) {
    for (let flat of res) {
      spot.apartmentScheme.forEach(function (value, index) {
        if (flat.floorID - 1 === index) {
          let res_ = value.filter(x => x.flatRoom === flat.roomCountID)[
            flat.columnID - 1
          ];
          if (res_) {
            res_.flatNumber = flat.flatNumber;
            res_.saleDate = flat.saleDate;
            res_.flatConfigurationID = flat.flatConfigurationID;
            res_.flatID = flat.id;
            res_.columnID = flat.columnID;
            res_.roomCountID = flat.roomCountID;
            res_.isCornerFlat = flat.isCornerFlat;
          }
        }
      });
    }
    this.loader = false;
  }

  getMaxFlatCount(rows: FloorInfoSet1[]) {
    return rows.reduce(function (prev, current) {
      return prev.flatCount > current.flatCount ? prev : current;
    }).flatCount;
  }

  updateObj(rows: FlatsFloorInfo) {
    let res: FloorInfoSet1Ex[] = [];
    res = rows.set1.map(r => {
      return {
        floorID: r.floorID,
        floorTitle: r.floorTitle,
        flatArea: r.flatArea,
        flatsArr: []
      };
    });
    res.forEach(f => {
      let infoCount = 0;
      let flats2 = rows.set2.filter(fi => fi.floorID === f.floorID);
      let flats1 = rows.set4.filter(fi => fi.floorID === f.floorID);

      f.flatsArr = flats2.map(fl => {
        let qwe: InfoAboutFlat[] = [];
        // for (let i = 0; i < fl.flatCount; i++) {
          // let flNumber = "";
          // let flID: number = null;
          // let isSold: boolean = false;
          // let isCornerFlat: boolean = false;
          // let flatArea: number = null;
          // let programID: number = null;
          if (flats1.length > 0) {
            // for (let prop in flats1) {
            let flatsByConfigurationID = flats1.filter(flat => flat.flatConfigurationID === fl.flatConfigurationID);
            if(flatsByConfigurationID.length > 0){
              flatsByConfigurationID.map((flat, index) => {
                  // flNumber = flat.flatNumber;
                  // flID = flat.id;
                  // flatArea = flat.flatArea;
                  // programID = flat.programID;
                  // isSold = flat.saleDate !== null ? true : false;
                  // isCornerFlat = flat.isCornerFlat ? true : false;
                let newIndex = qwe.length > 0 ? qwe.length : 0;
                // debugger;
                  qwe[newIndex] = {
                    flatID: flat.id,
                    flatNumber: flat.flatNumber,
                    columnID: index + 1,
                    roomCountID: fl.roomCountID,
                    flatConfigurationID: fl.flatConfigurationID,
                    isSale: flat.saleDate !== null ? true : false,
                    isCornerFlat: flat.isCornerFlat ? true : false,
                    flatArea: flat.flatArea
                  };
              });
            }
              // if (typeof flats1[prop].columnID !== "undefined") {
                // flats1[prop].columnID === i + 1 &&

                // if (flats1[prop].flatConfigurationID === fl.flatConfigurationID
                // ) {
                //   flNumber = flats1[prop].flatNumber;
                //   flID = flats1[prop].id;
                //   flatArea = flats1[prop].flatArea;
                //   programID = flats1[prop].programID;
                //   isSold = flats1[prop].saleDate !== null ? true : false;
                //   isCornerFlat = flats1[prop].isCornerFlat ? true : false;
                // }
              // }
            // }
          }
          // qwe[i] = {
          //   flatID: flID,
          //   flatNumber: flNumber,
          //   columnID: i + 1,
          //   roomCountID: fl.roomCountID,
          //   flatConfigurationID: fl.flatConfigurationID,
          //   isSale: isSold,
          //   isCornerFlat: isCornerFlat,
          //   flatArea: flatArea,
          //   cadastralFlatNumber: cadastralFlatNumber,
          //   programID: programID
          // };
        // }
        // console.log('QWE', qwe);
        // debugger;
        return {
          info: qwe
        };
      });

      f.flatsArr.map(r => {
        infoCount += r.info.length;
      });

      if (this.maxFlatCount > infoCount) {
        let infoEx: InfoAboutFlat[] = [];
        for (let i = 0; i < this.maxFlatCount - infoCount; i++) {
          infoEx[i] = {
            flatID: null,
            flatNumber: null,
            columnID: null,
            roomCountID: null,
            flatConfigurationID: null,
            isSale: false,
            isCornerFlat: false,
            flatArea: null
          };
        }
        f.flatsArr.push({
          info: infoEx
        });
      }
    });
    return res;
  }

  buildingIDeX: number;
  floorIDeX: number;
  roomCountIDeX: number;
  flatsEx;
  indexEx: number;
  flatIDeX: number;
  openConfirmDialog: boolean = false;
  deleteFlat(
    buildingID: number,
    floorID: number,
    roomCountID: number,
    flats,
    index: number,
    flatID: number
  ) {

    this.openConfirmDialog = true;
    this.buildingIDeX = buildingID;
    this.floorIDeX = floorID;
    this.roomCountIDeX = roomCountID;
    this.flatsEx = flats;
    this.indexEx = index;
    this.flatIDeX = flatID;
    // if (!confirm('Вы уверены, что хотите удалить квартиру?')) return false;
    // this.serverService.deleteSelectedFlat(buildingID, floorID, roomCountID, flatID).then(() => {
    //     flats[index] = 0;
    // });
  }

  deleteFlatEx(confirmAnswer: string) {
    if (confirmAnswer === 'yes') {
      this.serverService.deleteSelectedFlat(this.buildingIDeX, this.floorIDeX, this.roomCountIDeX, this.flatIDeX).then(() => {
        this.initializeSpotScheme(this.spotObject);
      });
      this.openConfirmDialog = false;
    }
    if (confirmAnswer === 'no') {
      this.openConfirmDialog = false;

    }
  }
  addBlocModal: boolean = false;
  editBlocModal: boolean = false;
  delBlock(id) {
    this.serverService.deleteBlock(id).then(() => {
      this.loadBlocks();
    });
  }

  selectedBlock: Block;
  openBlock(block: Block) {
    this.selectedBlock = block;
    this.editBlocModal = true;
  }

  addBlock() {
    this.serverService.insertBlock(this.block).then(() => {
      this.loadBlocks();
      this.block.blockNumber = "";
    });
    this.addBlocModal = false;
  }

  openAddBlock() {
    this.addBlocModal = true;
  }

  cancelAddBlock() {
    this.addBlocModal = false;
  }

  furnishModal: boolean = false;
  openFinishTemplate() {
    this.furnishModal = true;
  }

  furnishTemplate: OneFlatSalesSet2[] = [];
  getBuildingFurnishItemTemplate() {
    this.serverService
      .getBuildingFurnishItemTemplate(this.spotObject.id)
      .then(res => {
        this.furnishTemplate = res;
      });
  }

  getReturnFurnishes(list: OneFlatSalesSet2[]) {
    let furnishList = [];
    list.forEach(l => {
      furnishList.push(l.furnishItemID);
    });
    furnishList.join();
    this.serverService
      .setBuildingFurnishItemTemplate(this.spotObject.id, furnishList)
      .then(res => {
        this.getBuildingFurnishItemTemplate();
      });
  }


  closeAppartmentModal(event) {
    this.appartmentModal = event;
    this.countOfOpen = 1;
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
}

  duplicateBuilding() {
    this.serverService.copyBuilding(this.spotObject.id).subscribe((res: HttpResponse<any>) => {
      if (res.status === 200) {
        this.toastr.success('Изменения сохранены!', 'Успешно!');
        this.event.duplicateBuildiung.emit(true);
      }
    });
  }

  typicFloors: ITypicFloor[] = [];
  typicFloors2: ITypicFloor[] = [];
  typicFloorLoading: boolean = false;
  typicFloor: boolean = false;
  openTypicalFloor() {
    this.typicFloor = true;
    this.typicFloorLoading = true;
    this.serverService.getBuildingFlatsInfo(this.spotObject.id).then(res => {
      this.typicFloors = res.set1;
      this.typicFloors2 = res.set1;
      this.typicFloorLoading = false;
    });
  }


  selectedTypicFloorId: number;
  applyTypicFloors() {
    let toFloorIds: number[] = [];
    this.typicFloors.forEach(t => {
      if (t.hasOwnProperty('isChecked') && t.isChecked === true) {
        toFloorIds.push(t.floorID);
      }
    });
    this.serverService.copyFlats(this.spotObject.id, this.selectedTypicFloorId, toFloorIds).subscribe((res: HttpResponse<any>) => {
      if (res.status === 200) {
        this.toastr.success('Изменения сохранены!', 'Успешно!');
        this.init();
      }
    });
    this.cancelTypicFloors();
  }

  cancelTypicFloors() {
    this.typicFloor = false;
    this.selectedTypicFloorId = null;
  }

  radioChange() {
    this.typicFloors2 = this.typicFloors.filter(f => f.floorID != this.selectedTypicFloorId);
  }



}

interface ITypicFloor {
  floorID: number;
  floorTitle: string;
  isChecked?: boolean;
}
